import styled from 'styled-components';
import Modal from 'components/Modal';

export const View = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 48px;
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 24px;
`;

export const StatusText = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  text-align: center;

  color: #152946;
`;

export const InstructionText = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;

  color: #152946;
`;

export const Picture = styled.img`
  user-select: none;
  height: 80px;
`;

export const StyledModal = styled(Modal)`
  &-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    gap: 48px;
  }
`;
